import { type Transition, type Variant, type Variants } from 'framer-motion';

import { framerMotion } from '@pkg/primitives';

export enum MemeSharedVariant {
    Initial = 'sharedInitial',
    Show = 'sharedShow',
    Exit = 'sharedExit',
}

const memeCommonTransition: Transition = {
    staggerChildren: framerMotion.duration.fastest,
};

const memeCommonVariant: Variant = {
    transition: memeCommonTransition,
};

export const memeVariants: Variants = {
    [MemeSharedVariant.Initial]: memeCommonVariant,
    [MemeSharedVariant.Exit]: memeCommonVariant,
    [MemeSharedVariant.Show]: memeCommonVariant,
};

///
/// Thumbnail

const thumbnailCommonTransition: Transition = {
    type: 'spring',
    duration: framerMotion.duration.crawl,
};

export const thumbnailVariants: Variants = {
    [MemeSharedVariant.Initial]: {
        opacity: 0,
        rotate: -180,
        scale: 1.6,
        translateY: '-25%',
        transition: thumbnailCommonTransition,
    },
    [MemeSharedVariant.Show]: {
        opacity: 1,
        rotate: -6,
        scale: 1,
        translateY: '0%',
        transition: thumbnailCommonTransition,
    },
    [MemeSharedVariant.Exit]: {
        opacity: 0,
        rotate: 20,
        scale: 0.8,
        translateY: '200%',
        transition: {
            ease: framerMotion.easing.cubic,
            duration: framerMotion.duration.slowest,
        },
    },
};

///
/// Label

export const labelVariants: Variants = {
    [MemeSharedVariant.Initial]: {
        opacity: 0,
        translateY: '-40%',
    },
    [MemeSharedVariant.Show]: {
        opacity: 1,
        translateY: '0%',
    },
    [MemeSharedVariant.Exit]: {
        opacity: 0,
        translateY: '180%',
    },
};

export const labelTransition: Transition = {
    ease: framerMotion.easing.cubic,
    duration: framerMotion.duration.slow,
};
